import { Car, MapPin, SprayCan, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  { icon: Truck, title: "Mobile Service", sub: "We Come to You" },
  { icon: Car, title: "Interior + Exterior", sub: "Complete Vehicle Cleaning" },
  { icon: SprayCan, title: "Professional Equipment", sub: "Deep Cleaning & Extraction" },
  { icon: MapPin, title: "Local Service", sub: "Gap & Surrounding Areas" },
];

const TrustBar = () => (
  <section className="border-y border-white/10 bg-surface" data-testid="trust-bar" aria-label="Why choose us">
    <div className="mx-auto grid max-w-7xl grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      {ITEMS.map((item, i) => (
        <Reveal key={item.title} delay={i * 0.08} y={16}>
          <div
            className="flex items-center gap-4 border-white/10 px-6 py-7 sm:border-l sm:px-8 sm:first:border-l-0"
            data-testid={`trust-item-${i}`}
          >
            <item.icon size={26} strokeWidth={1.6} className="shrink-0 text-blue-500" aria-hidden="true" />
            <div>
              <p className="font-display text-lg font-semibold uppercase tracking-wide text-white">{item.title}</p>
              <p className="mt-0.5 text-sm text-slate-400">{item.sub}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default TrustBar;
